
export const STORE_FOOD_DATA = "STORE_FOOD_DATA";
export const STORE_STATIC_DATA = "STORE_STATIC_DATA";
export const STORE_DYNAMIC_DATA = "STORE_DYNAMIC_DATA";
export const CLEAR_FOOD_DATA = "CLEAR_FOOD_DATA";